import { createStore, combineReducers } from 'redux';
import userReducer from './reducers/userReducer';

// Combine all reducers
const rootReducer = combineReducers({
  user: userReducer,
});

// Create and configure store
const store = createStore(
  rootReducer,
  // Enable Redux DevTools extension
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

export default store;
